<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header" style="width: calc(100%-1000px);">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand">{{$route.name}}</a>
        <!-- <h1>{{ $store.state.userForm }}</h1> -->
      </div>
      <div class="fullname">{{ $store.state.userData ? ($store.state.userData.clientData.FirstName + ' ' + $store.state.userData.clientData.LastName) : "" }}
      </div>
      <span class="groupname" v-if="($route.path.includes('management') || ($route.path.includes('documents') && $store.state.managerData && !$store.state.userData)) && $store.state.managerData.GroupId !== 0">
        {{ $store.state.managerData.groups[0].TrustName }}
      </span>
      <div class="collapse navbar-collapse">
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      }
    }
  }

</script>
<style>

.fullname {
  font-size: 2em;
  font-weight: 600;
  line-height: 1.2em;
  font-family: 'Muli', "Helvetica", Arial, sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin-top: 15px;
  margin-right: 1em;
  text-align: center;
  float: right!important;
}

.groupname {
  float: right;
  text-align: right;
  padding-top: 1.5em;
  margin-right: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue